import { forwardRef } from "react";
import { Popover } from "react-bootstrap";
import { OverlayInjectedProps } from "react-bootstrap/esm/Overlay";
import { SvgSprite } from "./SvgSprite";

interface HotTipPopoverProps extends OverlayInjectedProps {
  id: string;
  hotTip: string;
  setCommitmentTooltip: React.Dispatch<
    React.SetStateAction<"event" | "more-than-6-months">
  >;
}

export const HotTipPopover = forwardRef<HTMLDivElement, HotTipPopoverProps>(
  (
    {
      hotTip,
      setCommitmentTooltip,
      placement,
      arrowProps,
      show,
      popper,
      ...rest
    },
    ref
  ) => {
    return (
      <Popover
        ref={ref}
        tabIndex={-1}
        placement={placement}
        arrowProps={{
          ...arrowProps,
          style: {
            position: "absolute",
            top: "calc(100% - 1px)",
            left: "0",
          },
        }}
        css={`
          .arrow {
            &:after {
              border-top-color: ${(p) => p.theme.infoColor};
            }
          }
        `}
        aria-hidden
        {...rest}
      >
        <div className="p-3 bg-info text-white ml-n2">
          <div className="d-flex mb-2">
            <h6 className="mb-0">Hot tip:</h6>
            <button
              type="button"
              aria-label="Close"
              onClick={(e) => {
                e.preventDefault();
                setCommitmentTooltip(null);
              }}
              css={`
                position: absolute;
                top: 0;
                right: 0;
              `}
              className="btn btn-link btn-sm text-white p-3 mt-n1 mr-n1 mb-0 border-0"
            >
              <SvgSprite id="icons:close" width={14} height={14} />
            </button>
          </div>
          <span>{hotTip}</span>
        </div>
      </Popover>
    );
  }
);
